import type {HelpFile} from '../../types/help'
import {AttributeAuthorityBadgeTestIds} from '../../../testids/AttributeAuthorityBadgeTestIds'

export const attributeAuthorityBadgeHelp: HelpFile = {
  docPage: '/docs/admin/attribute-authority',
  texts: {
    [AttributeAuthorityBadgeTestIds.attributeAuthorityBadge]:
      'Indicates which target system owns this attribute value. "Owned by …" means the value is maintained by an inbound sync — manual edits are blocked until authority is released. "Unclaimed" means the value can be edited freely; the next sync that touches the attribute will claim authority automatically.',
    [AttributeAuthorityBadgeTestIds.releaseAuthorityDialog]:
      'Confirm releasing authority. The attribute becomes editable from any source. The next inbound sync that writes to it claims authority again automatically.',
    [AttributeAuthorityBadgeTestIds.releaseAuthorityCancel]: null,
    [AttributeAuthorityBadgeTestIds.releaseAuthorityConfirm]:
      'Release authority. Use the amber/warning button — releasing is reversible (the next sync may claim authority again).',
    [AttributeAuthorityBadgeTestIds.transferAuthorityDialog]:
      'Transfer authority to a different target system. Only systems linked as a source for this record are eligible.',
    [AttributeAuthorityBadgeTestIds.transferAuthorityTargetTrigger]:
      'Pick the target system that should own this attribute next. If exactly one source is linked it is pre-selected.',
    [AttributeAuthorityBadgeTestIds.transferAuthorityCancel]: null,
    [AttributeAuthorityBadgeTestIds.transferAuthorityConfirm]: null,
    [AttributeAuthorityBadgeTestIds.transferAuthorityNoSources]:
      'No active sources are currently linked. Link a source first to be able to transfer authority.',
  },
}
